import Button from 'components/button/Button';
import styled from 'styled-components';

export const MenuButtonStyled = styled(Button)`
  border: none;
  padding: 0;
  margin-right: 10px;

  > span.glyphicon-menu-hamburger {
    font-size: 20px;
  }
`;
